import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import * as api from "../services/api";
import { useCart } from "../contexts/CartContext";
import "./SearchResults.css";

export default function SearchResults() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const query = searchParams.get("q") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { addToCart } = useCart();

  useEffect(() => {
    if (query) {
      searchProducts(query);
    } else {
      setProducts([]);
    }
  }, [query]);

  const searchProducts = async (searchQuery) => {
    if (!searchQuery.trim()) {
      setProducts([]);
      return;
    }

    try {
      setLoading(true);
      setError("");
      // Search across all categories - no category filter
      const results = await api.getProducts({ search: searchQuery.trim() });
      setProducts(results);
    } catch (error) {
      console.error("Error searching products:", error);
      setError("Failed to search products. Please try again.");
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="search-results-container">
      <div className="search-results-header">
        <button 
          onClick={() => navigate('/')} 
          className="back-button"
        >
          ← Back to Home
        </button>
        <div className="search-results-title-section">
          <h1>
            {query ? `Search Results for "${query}"` : "Search Products"}
          </h1>
          {query && (
            <p className="results-count">
              {loading ? (
                "Searching..."
              ) : (
                <>
                  Found <strong>{products.length}</strong> product
                  {products.length !== 1 ? "s" : ""}
                </>
              )}
            </p>
          )}
        </div>
      </div>

      {error && (
        <div className="search-error">
          <p>{error}</p>
        </div>
      )}

      {!query && (
        <div className="no-search-query">
          <p>Enter a search term to find products</p>
        </div>
      )}

      {loading && (
        <div className="search-loading">
          <p>Searching products...</p>
        </div>
      )}

      {!loading && query && products.length === 0 && !error && (
        <div className="no-results">
          <p>No products found for "{query}"</p>
          <p className="suggestions">
            Try searching with different keywords or check your spelling.
          </p>
        </div>
      )}

      {!loading && products.length > 0 && (
        <div className="search-results-grid">
          {products.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              onAddToCart={addToCart}
            />
          ))}
        </div>
      )}
    </div>
  );
}

